import "./Checkbox.scss"
import classNames from "classnames";
import "../picking-input.scss"

const Checkbox = ({label, onChange, required, checked, variant, reverse = true, name, description, formik}) => {
    const handleChange = (e) => {
        if(onChange){
            onChange(e);
        }

        if(formik){
            formik.setFieldValue(name, !formik.values[name]);
        }
    }


    return (
        <div className={classNames("checkbox", "picking-input", variant, {reverse})}>
            <input
                type="checkbox"
                name={name}
                onChange={handleChange}
                checked={formik ? formik.values[name] : checked}
            />
            <div>
                <label className={classNames({"required": required})}>{label}</label>
                {description && <p className="description">{description}</p>}
            </div>
        </div>
    )
}

export default Checkbox;